export const GMAT_SET_TOUR = "GMAT_SET_TOUR";
export const GMAT_SET_TOUR_BUSY = "GMAT_SET_TOUR_BUSY";
export const GMAT_SET_TOUR_ERROR = "GMAT_SET_TOUR_ERROR";
export const GMAT_SET_TOUR_COMPLETION = "GMAT_SET_TOUR_COMPLETION";
export const GMAT_RESET_TOUR = "GMAT_RESET_TOUR";
